namespace Matrix.Dashboards {
    export class DashboardColumns {
        static columnsKey = 'Dashboards.Dashboard';
    }
}
